import Component from '../abstracts/Component';
import Cookies from 'js-cookie';

/**
 Chat component
 */
export default class ChatComponent extends Component {

  // common selectors, overridable
  get SELECTORS() {
    return {
      //miaw chat enabled
      chatEnabled: '#chatEnabled',
      liveChatPersonalStylistCta: ".live-chat-personal-stylist-cta",
      // PS
      personalStylistPopUpTriggerTime: '#personalStylistPopUpTriggerTime',
      personalStylistBanner: '#liveChatPSCta',
      personalStylistStartChat: '#liveChatPSLaunch',
      personalStylistCloseBtn: '#liveChatPSCta .icon-close',
      chatBalloon: '#embedded-messaging',
      hidePersonalStylistForPage: 'data-hide-personal-stylist',
    };
  }

  get CLASSES() {
    return {
      hidden: 'hidden'
    }
  }

  constructor() {
    super();
    this.chatEnabled = document.querySelector(this.SELECTORS.chatEnabled).value;
    this.personalStylistPopUpTriggerTime = document.querySelector(this.SELECTORS.personalStylistPopUpTriggerTime).value.replace('.', '').replace(',', '');
  }

  readDOM() {
    return {
      chatBalloon: document.querySelector(this.SELECTORS.chatBalloon),
      personalStylistBanner : document.querySelector(this.SELECTORS.personalStylistBanner),
      personalStylistStartChat : document.querySelector(this.SELECTORS.personalStylistStartChat),
      personalStylistCloseBtn : document.querySelector(this.SELECTORS.personalStylistCloseBtn),
      liveChatPersonalStylistCta: document.querySelector(this.SELECTORS.liveChatPersonalStylistCta)
    }
  }

  // display PS button
  setupPersonalStylistDelayedPopup() {
    let isPSCookieSet = Cookies.get('hidePSBanner');
    // click start chat button
    if (this.dom.personalStylistBanner != null && isPSCookieSet !== 'true') {
      setTimeout(() => {
        const isChatBalloonDisplayed = this.readDOM().chatBalloon;
        if (isChatBalloonDisplayed) {
          this.readDOM().personalStylistBanner?.classList.remove(this.CLASSES.hidden);
          this.readDOM().liveChatPersonalStylistCta?.classList.remove(this.CLASSES.hidden);
        }
      }, this.personalStylistPopUpTriggerTime );
    }
  }

  hidePersonalStylistBanner() {
    // hide banner/button
    this.readDOM().personalStylistBanner?.classList.add(this.CLASSES.hidden);
    Cookies.set('hidePSBanner', 'true');
  }

  bindEvents() {
    // set PS as motivation in preChat, then launch
    const prechatFields = {
      "Type": {
        "value": "Personal_Stylist",
        "isEditableByEndUser": true
      }
    };

    this.dom.personalStylistStartChat?.addEventListener('click', (e) => {
      e.preventDefault();
      const chatAPI = window.embeddedservice_bootstrap;
      chatAPI.prechatAPI.setVisiblePrechatFields(prechatFields);
      chatAPI.utilAPI.launchChat();
    })
  }

  render() {
    // check if new chat is enabled
    // if is enabled let's launch PS
    if (this.chatEnabled === 'true') {
      this.dom = this.readDOM();
      this.bindEvents();
      this.setupPersonalStylistDelayedPopup();
      this.dom.personalStylistCloseBtn?.addEventListener('click', () => {
        this.hidePersonalStylistBanner();
      });
    }
  }
}
